<template>
  <v-dialog v-model="show" max-width="950px">
    <form-toolbar title="Record Extra Lifts"
                  :onSubmitClick="submitExtraLifts"
                  :disableSubmitValue="isSubmitDisabled()"
                  :onCloseClick="onCloseClick" />
    <v-card class="pa-1">
      <v-container>
        <div class="scrollable">
          <div v-for="(data, index) in extraLifts" :key="data.id">
            <component :ref="dynamicRef(data.id)" :is="data.component" :removeFormFromDialog="() => removeExtraLiftForm(index)" :formRefName="dynamicFormRef(data.id)"></component>
          </div>
        </div>
        <div>
          <v-btn :disabled="isAddNewLiftDisabled()"
                 color="primary"
                 @click="addExtraLift">
            Add New Lift
          </v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  import FormToolbar from '../ui/FormToolbar.vue';
  import RecordExtraLiftForm from './RecordExtraLiftForm.vue';
  import { ValidationObserver } from 'vee-validate';
  import { mapState } from 'vuex';

  export default {
    name: 'RecordExtraLiftsDialog',
    props: {
      value: Boolean,
      activity: {
        type: Object,
        required: true,
      },
      onCloseClick: Function,
      isOutbound: Boolean,
    },
    data() {
      return {
        extraLifts: [],
        id: 0,
      };
    },
    components: {
      FormToolbar,
      RecordExtraLiftForm,
      ValidationObserver,
    },
    computed: {
      ...mapState(['voyageReportsStore']),
      show: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
    },
    watch: {
      show(val) {
        if (!val) this.onCloseClick(this.activity);
      },
    },
    methods: {
      submitExtraLifts() {
        const promises = this.extraLifts.map((data) => {
          return new Promise((resolve) => {
            var child = this.$refs[`${data.id}extraLift`];
            child[0].$refs[`${data.id}form`].validate().then((isValid) => {
              resolve(isValid);
            });
          });
        });

        Promise.all(promises).then((results) => {
          const allValid = results.every((isValid) => isValid);

          if (allValid) {
            var extraLiftsToSubmit = [];
            const voyageReportId = this.activity.voyageReport ? this.activity.voyageReport.id : this.activity.voyageReportId;
            const flowVoyageId = this.isOutbound ? this.voyageReportsStore.eCargoVoyageCargo.outbound.voyageId : this.voyageReportsStore.eCargoVoyageCargo.inbound.voyageId;
            this.extraLifts.map((data) => {
              var child = this.$refs[`${data.id}extraLift`];
              var extraLiftToSubmit = {
                id: null,
                idc: null,
                activityId: this.activity.id,
                activityIdc: this.activity.idc,
                voyageReportId: voyageReportId,
                description: child[0].description,
                unitId: child[0].unitId,
                lineId: null,
                voyageId: flowVoyageId,
                offshoreLiftTime: this.activity.endDateTimeLt,
                isOutbound: this.isOutbound,
                destination: this.activity.locationName,
                activityEndDateTime: this.activity.endDateTimeLt,
                isNob: false,
                isExtra: true,
                length: child[0].length,
                width: child[0].width,
                quantity: parseInt(child[0].quantity),
                stackLevel: parseInt(child[0].stackLevel),
              };
              extraLiftsToSubmit.push(extraLiftToSubmit);
            });
            this.$store.dispatch('voyageReportsStore/recordExtraLifts', { lines: extraLiftsToSubmit, voyageReportId: voyageReportId })
              .then((resp) => {
                this.extraLifts = [];
                this.onSuccess('Extra Lifts added', resp);
              })
              .catch((err) => {
                this.onError('Failed to add Extra Lifts');
                console.error(err);
              });
          }
        });
      },
      addExtraLift() {
        this.extraLifts.push({ component: RecordExtraLiftForm, id: this.id });
        this.id++;
      },
      isAddNewLiftDisabled() {
        return this.extraLifts ? this.extraLifts.length >= 10 : false;
      },
      removeExtraLiftForm(index) {
        this.extraLifts.splice(index, 1);
      },
      isSubmitDisabled() {
        return this.extraLifts ? this.extraLifts.length === 0 : true;
      },
      dynamicRef(name) {
        return name + 'extraLift';
      },
      dynamicFormRef(name) {
        return name + 'form';
      },
      onSuccess(message, data) {
        this.$toast.success(message);
      },
      onError(message, data) {
        this.$toast.error(message);
      },
    },
  };
</script>

<style>
  .scrollable {
    max-height: 60vh; /* set your desired max height */
    overflow-y: auto;
    overflow-x: hidden;
  }
</style>
